import {
    Bars3Icon, ChartBarIcon, HomeIcon, XMarkIcon, BellIcon, DocumentCheckIcon, BuildingLibraryIcon, NewspaperIcon, BanknotesIcon, ArrowsRightLeftIcon, ArrowsPointingInIcon, ArrowPathRoundedSquareIcon,
    DocumentPlusIcon, DocumentMinusIcon, ClipboardDocumentListIcon, ClipboardDocumentCheckIcon, PencilSquareIcon, WindowIcon, ClipboardDocumentIcon, AcademicCapIcon, DocumentDuplicateIcon, DocumentTextIcon,
    UserIcon, IdentificationIcon, UserGroupIcon, DocumentMagnifyingGlassIcon, BellAlertIcon, PrinterIcon, LockClosedIcon, UserMinusIcon, ShieldCheckIcon, NoSymbolIcon, EnvelopeIcon, UserPlusIcon, HandRaisedIcon, CreditCardIcon, ComputerDesktopIcon, ArrowUpTrayIcon
} from '@heroicons/react/24/outline'

import {
    CashOffLogo, CircleDashedLogo, FileExportLogo, ReportMoney, ShoppingCartLogo, ParkingLogo, BuildingWarehouseLogo, ForkLiftLogo, InvoiceLogo, MathSymbolsLogo
} from './Logos'

const iconoRender = [
    { name: 'Bars3Icon', icono: Bars3Icon, },
    { name: 'ChartBarIcon', icono: ChartBarIcon, },
    { name: 'HomeIcon', icono: HomeIcon, },
    { name: 'XMarkIcon', icono: XMarkIcon, },
    { name: 'BellIcon', icono: BellIcon, },
    { name: 'DocumentCheckIcon', icono: DocumentCheckIcon, },
    { name: 'BuildingLibraryIcon', icono: BuildingLibraryIcon, },
    { name: 'NewspaperIcon', icono: NewspaperIcon, },
    { name: 'BanknotesIcon', icono: BanknotesIcon, },
    { name: 'ArrowsRightLeftIcon', icono: ArrowsRightLeftIcon, },
    { name: 'ArrowsPointingInIcon', icono: ArrowsPointingInIcon, },
    { name: 'ArrowPathRoundedSquareIcon', icono: ArrowPathRoundedSquareIcon, },
    { name: 'DocumentPlusIcon', icono: DocumentPlusIcon, },
    { name: 'DocumentMinusIcon', icono: DocumentMinusIcon, },
    { name: 'ClipboardDocumentListIcon', icono: ClipboardDocumentListIcon, },
    { name: 'ClipboardDocumentCheckIcon', icono: ClipboardDocumentCheckIcon, },
    { name: 'PencilSquareIcon', icono: PencilSquareIcon, },
    { name: 'WindowIcon', icono: WindowIcon, },
    { name: 'ClipboardDocumentIcon', icono: ClipboardDocumentIcon, },
    { name: 'AcademicCapIcon', icono: AcademicCapIcon, },
    { name: 'DocumentDuplicateIcon', icono: DocumentDuplicateIcon, },
    { name: 'DocumentTextIcon', icono: DocumentTextIcon, },
    { name: 'CashOffLogo', icono: CashOffLogo, },
    { name: 'CircleDashedLogo', icono: CircleDashedLogo, },
    { name: 'FileExportLogo', icono: FileExportLogo, },
    { name: 'ReportMoney', icono: ReportMoney, },
    { name: 'ShoppingCartLogo', icono: ShoppingCartLogo, },
    { name: 'ParkingLogo', icono: ParkingLogo, },
    { name: 'BuildingWarehouseLogo', icono: BuildingWarehouseLogo, },
    { name: 'ForkLiftLogo', icono: ForkLiftLogo, },
    { name: 'InvoiceLogo', icono: InvoiceLogo, },
    { name: 'MathSymbolsLogo', icono: MathSymbolsLogo, },
    { name: 'UserIcon', icono: UserIcon, },
    { name: 'IdentificationIcon', icono: IdentificationIcon, },
    { name: 'UserGroupIcon', icono: UserGroupIcon, },
    { name: 'DocumentMagnifyingGlassIcon', icono: DocumentMagnifyingGlassIcon, },
    { name: 'BellAlertIcon', icono: BellAlertIcon, },
    { name: 'PrinterIcon', icono: PrinterIcon },
    { name: 'LockClosedIcon', icono: LockClosedIcon },
    { name: 'UserMinusIcon', icono: UserMinusIcon },
    { name: 'ShieldCheckIcon', icono: ShieldCheckIcon },
    { name: 'NoSymbolIcon', icono: NoSymbolIcon },
    { name: 'NewspaperIcon', icono: NewspaperIcon },
    { name: 'EnvelopeIcon', icono: EnvelopeIcon },
    { name: 'UserPlusIcon', icono: UserPlusIcon },
    { name: 'NewspaperIcon', icono: NewspaperIcon },
    { name: 'HandRaisedIcon', icono: HandRaisedIcon },
    { name: 'CreditCardIcon', icono: CreditCardIcon },
    { name: 'ComputerDesktopIcon', icono: ComputerDesktopIcon },
    { name: 'ArrowUpTrayIcon', icono: ArrowUpTrayIcon },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const IconosMenu = ({ nameIcono, classes }) => {
    const IconoA = iconoRender?.find(x => x.name === nameIcono)
    const IconoS = IconoA?.icono
    return (
        <>
            {IconoS
                ? <IconoS className={classNames(classes)} aria-hidden="true" />
                : null
            }
        </>
    )
}